import React from "react";
import Pdf from "./Pdf";
import { PDFViewer } from "@react-pdf/renderer";

import Onlinebillpdf from "./OnlinebillPDF";

const PdfOnlineBillPreview = () => (
  <PDFViewer height={"1000"} width={"100%"}>
    <Onlinebillpdf />
  </PDFViewer>
);

export default PdfOnlineBillPreview;
